export default "__VITE_ASSET__CENIwcoe__"